import { type FC } from 'react';
import { Button, Grid, Stack } from '@mantine/core';
import { CascadeDangerZone } from './components/CascadeDangerZone';
import { CascadeEditorHeader } from './components/CascadeEditorHeader';
import { CascadeInfoCard } from './components/CascadeInfoCard';
import { CascadeQueueCard } from './components/CascadeQueueCard';
import { useCascadeEditor } from './lib';

interface CascadeEditorProps {
    id?: string;
}

export const CascadeEditor: FC<CascadeEditorProps> = ({ id }) => {
    const editor = useCascadeEditor(id);

    return (
        <Stack gap='md'>
            <CascadeEditorHeader
                isNew={editor.isNew}
                cascadeId={id}
            />

            <Grid gap='md'>
                <Grid.Col span={{ base: 12, md: 5 }}>
                    <Stack gap='md'>
                        <CascadeInfoCard
                            form={editor.form}
                            onSubmit={editor.handleSubmit}
                        />

                        <Button
                            type='submit'
                            form='cascade-info-form'
                            loading={editor.isSubmitPending}
                            disabled={editor.isSubmitPending}
                        >
                            Сохранить
                        </Button>

                        {!editor.isNew && (
                            <CascadeDangerZone
                                isPending={editor.isDeletePending}
                                onDelete={editor.handleDelete}
                            />
                        )}
                    </Stack>
                </Grid.Col>

                <Grid.Col span={{ base: 12, md: 7 }}>
                    <CascadeQueueCard
                        entries={editor.queueEntries}
                        onEntriesChange={editor.setQueueEntries}
                        groupOptions={editor.groupOptions}
                        templateOptions={editor.templateOptions}
                        isOptionsLoading={editor.isQueueOptionsLoading}
                        onAddGroup={editor.handleAddGroup}
                        onAddTemplate={editor.handleAddTemplate}
                        onClear={editor.handleClearQueue}
                    />
                </Grid.Col>
            </Grid>
        </Stack>
    );
};
